import { useState } from 'react'
import { useAbm } from '../hooks/useAbm'
import AbmTable from '../components/AbmTable'
import Modal from '../components/Modal'
import Boton from '../components/Boton'

const EMPTY = { descripcion: '', codigo_presea: '', tipo: 'efectivo', activo: true }
const TIPOS = ['efectivo', 'transferencia', 'tarjeta', 'cheque', 'mp']

export default function MediosPagoPage() {
  const { rows, loading, create, update, remove } = useAbm('medios-pago')
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState(EMPTY)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState('')

  const openCreate = () => { setForm(EMPTY); setErr(''); setModal('new') }
  const openEdit = (row) => { setForm({ ...row }); setErr(''); setModal(row) }

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErr('')
    try {
      if (modal === 'new') await create(form)
      else await update(modal.id, form)
      setModal(null)
    } catch (error) {
      setErr(error.response?.data?.message || 'Error al guardar')
    } finally { setSaving(false) }
  }

  const set = (key) => e => setForm(f => ({ ...f, [key]: e.target.value }))

  const columns = [
    { key: 'descripcion', label: 'Descripción' },
    { key: 'codigo_presea', label: 'Código Presea' },
    { key: 'tipo', label: 'Tipo' },
    { key: 'activo', label: 'Activo', render: v => v ? 'Sí' : 'No' },
  ]

  return (
    <div>
      <AbmTable title="Medios de Pago" columns={columns} rows={rows} loading={loading} onCreate={openCreate} onEdit={openEdit} onDelete={remove} />
      {modal && (
        <Modal title={modal === 'new' ? 'Nuevo Medio de Pago' : 'Editar Medio de Pago'} onClose={() => setModal(null)}>
          <form onSubmit={handleSave} style={styles.form}>
            <div>
              <label style={styles.label}>Descripción *</label>
              <input style={styles.input} value={form.descripcion} onChange={set('descripcion')} required />
            </div>
            <div style={styles.row}>
              <div style={styles.half}>
                <label style={styles.label}>Código Presea</label>
                <input style={styles.input} value={form.codigo_presea || ''} onChange={set('codigo_presea')} />
              </div>
              <div style={styles.half}>
                <label style={styles.label}>Tipo</label>
                <select style={styles.input} value={form.tipo} onChange={set('tipo')}>
                  {TIPOS.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
            </div>
            <label style={styles.checkRow}>
              <input type="checkbox" checked={form.activo} onChange={e => setForm(f => ({ ...f, activo: e.target.checked }))} />
              Activo
            </label>
            {err && <p style={styles.error}>{err}</p>}
            <div style={styles.actions}>
              <Boton variante="ghost" type="button" onClick={() => setModal(null)}>Cancelar</Boton>
              <Boton variante="primary" type="submit" disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Boton>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const styles = {
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  row: { display: 'flex', gap: '0.75rem' },
  half: { flex: 1 },
  label: { display: 'block', fontWeight: '600', fontSize: '0.875rem', color: '#374151', marginBottom: '0.25rem' },
  input: { width: '100%', padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.9375rem', boxSizing: 'border-box' },
  checkRow: { display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', cursor: 'pointer' },
  error: { color: '#dc2626', fontSize: '0.875rem', margin: 0 },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '0.5rem' },
}
